export default {
  title: {
    id: 'hub_buying_guide_footer_title',
    defaultMessage: 'See all articles',
  },
} as const
